"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var StorageApi = /** @class */ (function () {
    function StorageApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询存酒项
     * @method GET 查询存酒项
     *
     */
    StorageApi.prototype.Storage = function () {
        return this.http
            .url("/api/Storage")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询提货申请
     * @method GET 查询提货申请
     *
     */
    StorageApi.prototype.take = function () {
        return this.http
            .url("/api/Storage/take")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 发货
     * @method POST 发货
     *
     * @params id 无说明
     */
    StorageApi.prototype.deliver = function (id) {
        return this.http
            .url("/api/Storage/take/" + id + "/deliver")
            .addSecurityHeaders()
            .support('POST');
    };
    StorageApi.diOptions = di_1.default.options({
        name: "StorageApi",
        scope: "Singleton"
    });
    return StorageApi;
}());
exports.StorageApi = StorageApi;
exports.default = StorageApi;
